import React, { Component } from 'react';
import { StyledContainer, StyledWrapper } from './style';
import BankAccountSection from './bankAccount';
import IRPFDataSection from './IRPFData';
import AddressSection from './addressSection';

import { fiscalDataMenu } from '../../../../constants/menuTabs';
import DataFormUser from '../../../views/DataFormUser';

class FiscalData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSection: 'otrosDatos'
    };
  }

  render() {
    const { currentSection } = this.state;

    const changeSection = section => {
      this.setState({ currentSection: section.id });
    };

    const getContent = section => {
      switch (section) {
        case 'DomicilioPersonal':
          return (
            <AddressSection cancel={() => changeSection(fiscalDataMenu[3])} />
          );
        case 'DatosDomBancaria':
          return (
            <BankAccountSection
              cancel={() => changeSection(fiscalDataMenu[3])}
            />
          );
        case 'DatosIRPF':
          return (
            <IRPFDataSection cancel={() => changeSection(fiscalDataMenu[3])} />
          );
        case 'otrosDatos':
        default: {
          return (
            <DataFormUser
              editMode
              changeAddress={() => changeSection(fiscalDataMenu[0])}
              changeBankAccount={() => changeSection(fiscalDataMenu[1])}
              changeIrpf={() => changeSection(fiscalDataMenu[2])}
            />
          );
        }
      }
    };
    return (
      <StyledContainer>
        <StyledWrapper>
          <div>{getContent(currentSection)}</div>
        </StyledWrapper>
      </StyledContainer>
    );
  }
}

export default FiscalData;
